export default __webpack_public_path__ + "55b17ae4f1ad822a8bff2679bafb9a60.png";